export const selectAll = (data, value: boolean) => {
  const temp = {...data}
  const newValue = value === true ? 1 : 0

  const keys = ['List', 'constants', 'operation']
  keys.forEach(key => {
    data[key].forEach(o => {
      o.value = newValue
    })
  })

  return temp
}

export const selectOneItem = (data: [], sectionKey: string, EnName: string, value: boolean) => {

  const newValue = value === true ? 1 : 0
  const temp = {...data};
  temp[sectionKey].filter(v => v.EnName === EnName)[0].value = newValue
  return temp
}

export const makeNewArrayOfEmptyFields = (emptyFields, value, checked) => {

  const tempEmptyFields = [...emptyFields]

  // if checked And There were not that Value in Array  So I Must Delete It
  // if Unchecked And There was that Value in Array  So I Must Delete It

  if (checked) {
    if (tempEmptyFields.includes(value)) {
      const indexOfValue = tempEmptyFields.indexOf(value)
      tempEmptyFields.splice(indexOfValue, 1);
    }
  } else {
    if (!tempEmptyFields.includes(value)) {
      tempEmptyFields.push(value)
    }
  }
  return tempEmptyFields;
}

export const replaceNewExceptionFields = (data, exceptionFields, EnName, sectionKey) => {
  const tempData = {...data}
  tempData[sectionKey].forEach(v => {
    if (v.EnName === EnName) {
      v.exceptionFields = exceptionFields
    }
  })

  return tempData
}